import React from "react";

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-8 flex items-center justify-center">
      <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-lg p-6 text-center">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">About Vorlas</h1>
        <p className="text-lg text-gray-600 mb-8">
          Information about the Vorlas platform will go here.
        </p>
        {/* Remove Back to Home link */}
        {/* 
        <Link to="/" className="text-blue-500 hover:underline">
          &larr; Back to Home
        </Link> 
        */}
      </div>
    </div>
  );
};

export default About;
